const configuredLocales = [
  ["zh-CN", "简体中文"],
  ["zh-TW", "繁體中文"],
  ["en-US", "English (United States)"],
  ["en-GB", "English (United Kingdom)"],
  ["ja-JP", "日本語"],
  ["ko-KR", "한국어"],
  ["de-DE", "Deutsch"],
  ["fr-FR", "Français"],
  ["es-ES", "Español"],
  ["pt-BR", "Português (Brasil)"],
  ["ru-RU", "Русский"],
] as const;

export type SelectOption = { value: string; label: string };

const configuredLocaleOptions: SelectOption[] = configuredLocales.map(([value, label]) => ({
  value,
  label,
}));

const timeZoneApi = Intl as typeof Intl & {
  supportedValuesOf?: (key: "timeZone") => string[];
};

const supportedTimeZones = Array.from(new Set([
  "UTC",
  ...(timeZoneApi.supportedValuesOf?.("timeZone") ?? [
    "Asia/Taipei",
    "Asia/Shanghai",
    "Asia/Hong_Kong",
    "Asia/Tokyo",
    "Asia/Seoul",
    "Asia/Singapore",
    "Asia/Bangkok",
    "Asia/Kolkata",
    "Europe/London",
    "Europe/Berlin",
    "Europe/Paris",
    "Europe/Moscow",
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Los_Angeles",
    "America/Sao_Paulo",
    "Australia/Sydney",
  ]),
])).sort((left, right) => left.localeCompare(right));

const supportedTimeZoneOptions: SelectOption[] = supportedTimeZones.map((value) => ({
  value,
  label: value.replaceAll("_", " "),
}));

export function localeOptions(current: string): SelectOption[] {
  return withCurrent(configuredLocaleOptions, current);
}

export function timeZoneOptions(current: string): SelectOption[] {
  return withCurrent(supportedTimeZoneOptions, current);
}

function withCurrent(options: SelectOption[], current: string): SelectOption[] {
  if (!current || options.some((option) => option.value === current)) return options;
  return [{ value: current, label: current }, ...options];
}
